var map = {
	"./news-12-1.jpg": 54752,
	"./news-12-10.jpg": 71674,
	"./news-12-11.jpg": 39959,
	"./news-12-12.jpg": 1288,
	"./news-12-13.jpg": 28901,
	"./news-12-14.jpg": 86014,
	"./news-12-15.jpg": 6171,
	"./news-12-2.jpg": 21391,
	"./news-12-3.jpg": 61362,
	"./news-12-4.jpg": 73057,
	"./news-12-5.jpg": 95012,
	"./news-12-6.jpg": 95059,
	"./news-12-7.jpg": 23446,
	"./news-12-8.jpg": 99909,
	"./news-12-9.jpg": 55944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20254;